// extracted by mini-css-extract-plugin
export default {"thumb":"MockThumb_thumb__TCvDO"};